import { render, staticRenderFns } from "./OctAccountHeader.vue?vue&type=template&id=72d83a77&scoped=true&"
import script from "./OctAccountHeader.vue?vue&type=script&lang=js&"
export * from "./OctAccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./OctAccountHeader.vue?vue&type=style&index=0&id=72d83a77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d83a77",
  null
  
)

export default component.exports